import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Dialog, withStyles } from "@material-ui/core";
import Clear from "@material-ui/icons/Clear";
import styles from "./HandOver.module.scss";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Datetime from "react-datetime";
import "../../../../styles/DateTime.scss";
import CustomerReservationsClient from "../../../../shared/clients/CustomerReservationsClient";
import { HANDOVER_DIALOGUES, HANDOVER_STATUS } from "./Constants";

const StyledClear = withStyles({
  root: {
    width: 27,
    height: 27,
    fill: "#102b4e",
    align: "right",
  },
})(Clear);

const StyledDialog = withStyles({
  paper: {
    maxWidth: 607,
    height: 616,
  },
})(Dialog);

class HandOverAppointmentDialog extends Component {
  constructor(props) {
    super(props);
    this.yesterdayDate = this.getYesterdayDate();
  }

  handleClose = () => {
    this.props.handleDialogChange(
      null,
      HANDOVER_DIALOGUES.APPOINTMENT,
      this.props.fromReschedule ? null : HANDOVER_DIALOGUES.APPOINTMENT
    );
  };

  handleCancel = () => {
    this.props.handleDialogChange(
      null,
      HANDOVER_DIALOGUES.APPOINTMENT,
      this.props.fromReschedule ? null : HANDOVER_DIALOGUES.APPOINTMENT
    );
  };

  handleSave = () => {
    this.props.handleDialogChange(null, HANDOVER_DIALOGUES.APPOINTMENT);
    const handOverData = this.getHandOverData();

    this.props.hideOrShow(true);
    CustomerReservationsClient.updateHandOver(
      this.props.token,
      handOverData,
      this.props.customerReservation.id
    )
      .then(() => {
        this.props.refreshOrderDetails();
      })
      .catch(() => {
        this.props.showErrorPopup(
          this.props.t("Error.processingErrorTitle"),
          this.props.t("Error.processingErrorMessage")
        );
      })
      .finally(() => {
        this.props.hideOrShow(false);
      });
  };

  getYesterdayDate = () => {
    if (
      this.props.customerReservation &&
      this.props.customerReservation.todayDate
    ) {
      const dateString = this.props.customerReservation.todayDate;
      const year = dateString.substring(0, 4);
      const month = dateString.substring(5, 7);
      const day = dateString.substring(8, 10);

      const todayDate = new Date(year, month - 1, day);
      todayDate.setDate(todayDate.getDate() - 1);

      return todayDate;
    } else return null;
  };

  getHandOverData() {
    return {
      appointmentStatus: this.props.fromReschedule
        ? HANDOVER_STATUS.RESCHEDULED
        : HANDOVER_STATUS.ACCEPTED,
      preferredNotesToDealer: "",
      dealerUserId: this.props.user.userId,
      preferredAppointmentDate: this.formatAppointmentDate(),
      preferredAppointmentTime: this.formatAppointmentTime(),
      paymentType: this.props.customerReservation.paymentType,
    };
  }

  formatAppointmentDate = () => {
    const date = this.preferredAppointmentDate.split("-");
    const year = date[0].substring(0, 4);
    let month = parseInt(date[1]) + 1;
    if (month < 10) {
      month = "0" + month;
    }
    let day = date[2];
    if (day.length < 2) {
      day = "0" + day;
    }
    return year + "-" + month + "-" + day;
  };

  formatAppointmentTime = () => {
    if (this.preferredAppointmentTime === null) {
      return "00:00";
    } else {
      const time = this.preferredAppointmentTime.split(":");
      let hours = time[0];
      let minutes = time[1];
      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      return hours + ":" + minutes;
    }
  };
  updateDateTime = (date) => {
    this.preferredAppointmentDate =
      date.get("year") + "-" + date.get("month") + "-" + date.get("date");

    this.preferredAppointmentTime = date.get("hour") + ":" + date.get("minute");
  };

  startDate = () => {
    const dateString = this.props.preferredAppointmentDate;
    const year = dateString.substring(0, 4);
    const month = parseInt(dateString.substring(5, 7)) - 1;
    const day = dateString.substring(8, 10);

    const time = this.props.preferredAppointmentTime;

    const date = new Date(year, month, day);
    if (time) {
      const times = time.split(":");
      if (times.length > 1) {
        date.setHours(
          parseInt(times[0].trim()) + (time.includes("PM") ? 12 : 0)
        );
        date.setMinutes(parseInt(times[1].trim()));
      }
    }

    this.preferredAppointmentDate = year + "-" + month + "-" + day;
    this.preferredAppointmentTime = this.props.preferredAppointmentTime;

    return date;
  };

  formatTodayDate = (current) => {
    return current.isAfter(this.yesterdayDate);
  };

  render() {
    const fromReschedule = this.props.fromReschedule;

    return this.props.open ? (
      <StyledDialog open={this.props.open} onClose={this.handleClose}>
        <div className={styles.dialog}>
          <Grid
            container
            data-testid="handOverAppointmentDialog"
            className={styles.dialogContainer}
            justify="center"
          >
            <Grid item md={12} className={styles.cancel}>
              <div>
                <button
                  data-testid="handOverAppointmentCloseDialog"
                  onClick={this.handleClose}
                >
                  <StyledClear />
                </button>
              </div>
            </Grid>

            <Grid item md={9}>
              <div className={styles.dialogTitle}>
                {fromReschedule
                  ? this.props.t("HandOverAppointmentDialog.reschedule")
                  : this.props.t("HandOverAppointmentDialog.title")}
              </div>
            </Grid>

            <Grid item md={9}>
              <div className={styles.body}>
                <div className={styles.text}>
                  {fromReschedule
                    ? this.props.t("HandOverAppointmentDialog.bodyReschedule")
                    : this.props.t("HandOverAppointmentDialog.bodyText")}
                </div>

                <div className={styles.paddingTop}>
                  <Datetime
                    ref="datetime"
                    initialViewMode="time"
                    open={true}
                    input={false}
                    dateFormat="DD MMM YYYY"
                    timeFormat="HH:mm"
                    onChange={this.updateDateTime}
                    initialValue={this.startDate()}
                    isValidDate={this.formatTodayDate}
                  />
                </div>
              </div>
            </Grid>

            <Grid item md={9}>
              <div className={styles.dialogActions}>
                <Button
                  className={styles.cancel}
                  name="handOverAppointmentCancel"
                  data-testid="handOverAppointmentCancel"
                  onClick={this.handleCancel}
                >
                  {this.props.t("HandOverAppointmentDialog.cancel")}
                </Button>
                <Button
                  className={styles.next}
                  name="handOverAppointmentSave"
                  data-testid="handOverAppointmentSave"
                  onClick={this.handleSave}
                >
                  {this.props.t("HandOverAppointmentDialog.save")}
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>
      </StyledDialog>
    ) : (
      ""
    );
  }
}

export default withTranslation("emp")(HandOverAppointmentDialog);
